import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMedicationsreact = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M13.1802 10.4272L16.7562 6.77781C19.0668 4.4305 22.8628 4.40299 25.2102 6.7228C27.5575 9.03344 27.585 12.8295 25.2652 15.1768L21.6892 18.8261",
		stroke: "#B5BECA",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.71592 17.0382C4.40529 19.3764 4.43279 23.1449 6.77094 25.4555C9.10908 27.7662 12.8776 27.7387 15.1883 25.4005L21.6892 18.8354C20.2313 20.3116 17.5172 18.6612 15.4633 16.6348C13.4094 14.6084 11.7315 11.9126 13.1802 10.4364L6.71592 17.0382Z",
		stroke: "#B5BECA",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgMedicationsreact;
